import { MenuOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import {
  SortableContainer,
  SortableContainerProps,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc';

const dragRow = css`
  background: var(--fett-bg-hover);
  border: 1px solid var(--fett-border-strong);

  & td {
    padding: 16px;
  }

  & .drag-visible {
    visibility: visible;
  }
`;

export const DragHandle = SortableHandle(() => (
  <MenuOutlined style={{ cursor: 'grab', color: 'var(--fett-text-icon-muted)' }} />
));

export const SortableItem = SortableElement((props: React.HTMLAttributes<HTMLTableRowElement>) => (
  <tr style={{ zIndex: 9999 }} {...props} />
));

export const SortableBody = SortableContainer(
  (props: React.HTMLAttributes<HTMLTableSectionElement>) => <tbody {...props} />,
);

export const DraggableContainer = (props: SortableContainerProps) => (
  <SortableBody useDragHandle disableAutoscroll helperClass={dragRow} {...props} />
);
